import './pagination-controls.scss';

const getPaginationItems = (currentPage, totalPages) => {
    if (totalPages <= 7) {
        return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pages = new Set([1, totalPages, currentPage]);

    if (currentPage <= 4) {
        [2, 3, 4, 5].forEach((page) => pages.add(page));
    } else if (currentPage >= totalPages - 3) {
        [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1].forEach((page) => pages.add(page));
    } else {
        [currentPage - 1, currentPage + 1].forEach((page) => pages.add(page));
    }

    return [...pages]
        .filter((page) => page >= 1 && page <= totalPages)
        .sort((a, b) => a - b)
        .reduce((items, page, index, sortedPages) => {
            if (index > 0 && page - sortedPages[index - 1] > 1) {
                items.push(`ellipsis-${sortedPages[index - 1]}-${page}`);
            }

            items.push(page);
            return items;
        }, []);
};

const PaginationControls = ({
    currentPage,
    totalPages,
    onPageChange,
    previousLabel = 'Prev',
    nextLabel = 'Next'
}) => {
    if (totalPages <= 1) {
        return null;
    }

    const paginationItems = getPaginationItems(currentPage, totalPages);

    return (
        <nav className="pagination-controls" aria-label="Image pages">
            <button
                type="button"
                className="pagination-button"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous page"
            >
                {previousLabel}
            </button>

            <div className="pagination-pages">
                {paginationItems.map((item) => {
                    if (typeof item === 'string') {
                        return (
                            <span
                                key={item}
                                className="pagination-ellipsis"
                                aria-hidden="true"
                            >
                                ...
                            </span>
                        );
                    }

                    return (
                        <button
                            type="button"
                            key={item}
                            className={`pagination-button page-number ${item === currentPage ? 'active' : ''}`}
                            onClick={() => onPageChange(item)}
                            aria-label={`Page ${item}`}
                            aria-current={item === currentPage ? 'page' : undefined}
                        >
                            {item}
                        </button>
                    );
                })}
            </div>

            <button
                type="button"
                className="pagination-button"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next page"
            >
                {nextLabel}
            </button>
        </nav>
    );
};

export default PaginationControls;
